export const ALERT_SETTINGS_CHANGE = 'ALERT_SETTINGS_CHANGE';
export const ALERT_SETTINGS_SAVE_REQUEST = 'ALERT_SETTINGS_SAVE_REQUEST';

export const ALERT_SETTINGS_CHANGE_REQUEST = 'ALERT_SETTINGS_CHANGE_REQUEST';
export const ALERT_SETTINGS_CHANGE_SUCCESS = 'ALERT_SETTINGS_CHANGE_SUCCESS';
export const ALERT_SETTINGS_CHANGE_FAIL = 'ALERT_SETTINGS_CHANGE_FAIL';

export const alertSettingsChange = setting => ({
  type: ALERT_SETTINGS_CHANGE,
  setting,
});

export const alertSettingsSaveRequest = setting => ({
  type: ALERT_SETTINGS_SAVE_REQUEST,
  setting,
});

export const alertSettingsChangeRequest = setting => ({
  type: ALERT_SETTINGS_CHANGE_REQUEST,
  setting,
});

export const alertSettingsChangeSuccess = setting => ({
  type: ALERT_SETTINGS_CHANGE_SUCCESS,
  setting,
});

export const alertSettingsChangeFail = setting => ({
  type: ALERT_SETTINGS_CHANGE_FAIL,
  setting,
});

export default {
  alertSettingsChange,
  alertSettingsChangeRequest,
};
